
import React from "react";
import { Card, CardContent, Typography } from "@mui/material";

export default function SummaryStatCard({ title, value, help, accent = "info" }) {
    
    return (
        <Card className="rounded-2xl shadow-sm">
            <CardContent className="space-y-1">
                <Typography variant="body2" color="text.secondary">
                    {title}
                </Typography>
                <Typography variant="h5" className="font-semibold tracking-tight">
                    {value}
                </Typography>
                {help && (
                    <Typography variant="caption" color="text.secondary">
                        {help}
                    </Typography>
                )}
            </CardContent>
        </Card>
    );
}